import "./FabOurTeam.css";

function FabOurTeam({ page, settings }) {
  const content = page?.content || {};
  const themeMode =
    String(settings?.theme_mode || "dark").trim().toLowerCase() === "light"
      ? "light"
      : "dark";

  const title = content.title?.trim() || "BECOME PART OF FAB";

  const cards = [
    {
      image_url: content.card1_image_file || "/ourTeam1.jpg",
      title: content.card1_title || "EXPANSION PARTNER",
      description:
        content.card1_description ||
        "League Expansion Partner plays a pivotal role in building brand awareness and spearheading the expansion into untapped markets. Working under FAB’s license, you will enjoy the autonomy to implement strategic initiatives and drive growth in accordance with FAB’s vision.",
      button_label: content.card1_button_label || "Learn More",
      button_link: content.card1_button_link || "/contact",
    },
    {
      image_url: content.card2_image_file || "/ourTeam2.jpg",
      title: content.card2_title || "BECOME AN OFFICIAL",
      description:
        content.card2_description ||
        "We provide comprehensive training and support to all our referees, equipping you with the knowledge and skills needed to excel on the court. Whether you're a seasoned referee or just starting out, there's a place for you on our team.",
      button_label: content.card2_button_label || "Learn More",
      button_link: content.card2_button_link || "/contact",
    },
    {
      image_url: content.card3_image_file || "/ourTeam3.jpg",
      title: content.card3_title || "BECOME A SCOREKEEPER",
      description:
        content.card3_description ||
        "As a scorekeeper, you'll play a vital role in ensuring smooth and accurate game operations. You'll be responsible for tracking scores, fouls, timeouts, and other essential game details, helping to maintain the integrity and fairness of each match.",
      button_label: content.card3_button_label || "Learn More",
      button_link: content.card3_button_link || "/contact",
    },
  ];

  return (
    <div className={`fab-our-team ${themeMode}`}>
      <div className="fab-our-team__inner">
        <h1>{title}</h1>

        <div className="fab-our-team__grid">
          {cards.map((card, idx) => (
            <div key={idx} className="fab-our-team__card">
              {card.image_url && (
                <img src={card.image_url} alt={card.title || `Card ${idx + 1}`} />
              )}

              <h4>{card.title}</h4>
              <p>{card.description}</p>

              {card.button_link && (
                <a
                  href={
                    card.button_link?.startsWith("http://") ||
                      card.button_link?.startsWith("https://")
                      ? card.button_link
                      : `/${String(card.button_link || "").replace(/^\/+/, "")}`
                  }
                  target={
                    card.button_link?.startsWith("http://") ||
                      card.button_link?.startsWith("https://")
                      ? "_blank"
                      : undefined
                  }
                  rel={
                    card.button_link?.startsWith("http://") ||
                      card.button_link?.startsWith("https://")
                      ? "noopener noreferrer"
                      : undefined
                  }
                >
                  <button type="button">
                    {card.button_label?.trim() || "Learn More"}
                  </button>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FabOurTeam;